import { create } from 'zustand';

import { clearServiceId, setServiceId } from '@/api/tokens.helper';
import { useAuth } from '@/store/auth/auth.store';

export type ServiceType = 'vessel' | 'service-provider';

type ActiveAccountState = {
  serviceId?: string;
  serviceType?: ServiceType;
  /** True from an account switch until the new service's role and rights are in place. */
  switching: boolean;
  /**
   * Bumped on every account switch. The shell keys the route on it, so the page mounts afresh
   * and its widgets fetch for the new service instead of rendering the old one's data.
   */
  generation: number;
  /** The role and rights lookup the last `setActiveAccount` started. */
  roleUpdate: Promise<void>;
  setActiveAccount: (serviceId: string, serviceType: ServiceType) => void;
  clearActiveAccount: () => void;
};

export const useActiveAccount = create<ActiveAccountState>((set) => ({
  switching: false,
  generation: 0,
  roleUpdate: Promise.resolve(),
  setActiveAccount: (serviceId, serviceType) => {
    setServiceId(serviceId);
    set({
      serviceId,
      serviceType,
      roleUpdate: useAuth.getState().updateRoleForVessel(serviceId),
    });
  },
  clearActiveAccount: () => {
    set({ serviceId: undefined, serviceType: undefined });
    clearServiceId();
  },
}));
